'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = '__THEMING__';


//////////////////
// WEBPACK FOOTER
// ./~/theming/dist/cjs/channel.js
// module id = ./node_modules/theming/dist/cjs/channel.js
// module chunks = 4016850265702045000 14635644658655486000